import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import PharmacyAuthGuard from 'src/auth/guard/pharmacy-auth-guard';
// layouts
import PharmacyDashboardLayout from 'src/layouts/pharmacy-dashboard/layout';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// eslint-disable-next-line import/no-unresolved
const IndexPage = lazy(() => import('src/pages/pharmacy-dashboard/pharmacy-dashboard-home'));

// ----------------------------------------------------------------------

export const pharmacyDashboardRoutes = [
  {
    path: 'pharmacy-dashboard',
    element: (
      <PharmacyAuthGuard>
        <PharmacyDashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </PharmacyDashboardLayout>
      </PharmacyAuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
    ],
  },
];
